/// <reference types="@types/googlemaps" />
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ApplicationRef,
  ContentChild,
} from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
  ServiceProviderCasePostPut,
  EServicePlace,
  ServiceProviderCaseService,
  ServiceProviderCaseCustomerUserProductSelect,
  ErrorTypeService,
  ErrorTypeListResponse,
  CustomerCaseService,
  ECaseReason,
  ECaseStatusRequest,
  ECaseStatus,
} from "../../../api";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { CustomdatepickerComponent } from "../../../../shared/modules/customdatepicker.component";
import { Subject, Observable, of, concat } from "rxjs";
import {
  distinctUntilChanged,
  debounceTime,
  switchMap,
  tap,
  catchError,
} from "rxjs/operators";

@Component({
  selector: "app-case",
  templateUrl: "./myCase.component.html",
  styleUrls: ["./myCase.component.scss"],
})
export class MyCaseComponent implements OnInit {
  @ViewChild("addr") public searchElement: ElementRef;
  @ContentChild(CustomdatepickerComponent)
  datepickerViewChild: CustomdatepickerComponent;

  caseForm: FormGroup;
  customers;
  defaultCustomers;
  customers$: Observable<ServiceProviderCaseCustomerUserProductSelect[]>;
  errorTypes: ErrorTypeListResponse[];
  user;
  fullname = "";
  selectedCustomer: any;
  products = [];
  shopList = [];
  caseList: any[] = [];
  customerAddress;
  repair;
  types = ["SupportingRequest"];
  case: ServiceProviderCasePostPut;
  total;
  bike;
  today = new Date();
  minDate = {
    year: this.today.getFullYear(),
    month: this.today.getMonth() + 1,
    day: this.today.getDate(),
  };
  filter = {
    page: 1,
    limit: 30,
    search: "",
  };
  init = true;
  isLoading = false;
  customerInput$ = new Subject<string>();
  constructor(
    public activeModal: NgbActiveModal,
    private cs: ServiceProviderCaseService,
    private errorTypeService: ErrorTypeService,
    private app: ApplicationRef,
    private spc: ServiceProviderCaseService,
    private ccs: CustomerCaseService  ) {}

  ngOnInit() {
    this.getCustomer();
    this.spc
      .apiServiceProviderCasesRepairshopDistanceToCustomerByCustomerIdGet("")
      .subscribe((data) => {
        this.shopList = data;
      });
    this.ccs.apiCustomerCasesUserProductSelectGet().subscribe((data) => {
      this.products = data;
      console.log(this.products)
    });
    if (this.user) {
      this.filter.search = this.fullname;
    }
    this.cs
      .apiServiceProviderCasesCustomerUserProductSelectGet(
        this.filter.page,
        this.filter.limit,
        this.filter.search
      )
      .subscribe((data) => {
        this.customers = data;
        this.defaultCustomers = data;
        if (this.user) {
          this.customers.forEach((element) => {
            if (element.customerId === this.user.repairShopId) {
              this.products = element.userProductSelects;
              if (this.products.length === 1) {
                this.bike = this.products[0].userProductId;
              }
              return;
            }
          });
        }
      });
    this.errorTypeService.apiErrorTypesGet(1).subscribe((data) => {
      this.errorTypes = data;
    });
    this.customerInput$.next("1");
    this.caseForm = new FormGroup({
      errorType: new FormControl(null, [Validators.required]),
      product: new FormControl(null, [Validators.required]),
      subject: new FormControl(null, [
        Validators.required,
        Validators.maxLength(32),
      ]),
      shop: new FormControl(null, [Validators.required]),
      description: new FormControl(null, [Validators.required]),
      servicePlace: new FormControl("AtRepairshop"),
    });
    if (this.user) {
      this.caseForm.controls.customer.disable();
    }
    if (this.bike) {
      this.caseForm.controls.subject.disable();
    }
    this.servicePlace.valueChanges.subscribe(() => this.app.tick());
  }

  
  get product() {
    return this.caseForm.get("product");
  }
  get subject() {
    return this.caseForm.get("subject");
  }
  get description() {
    return this.caseForm.get("description");
  }
  get servicePlace() {
    return this.caseForm.get("servicePlace");
  }
  get shop() {
    return this.caseForm.get("shop");
  }
  get errorType() {
    return this.caseForm.get("errorType");
  }
  getCustomer() {
    this.customers$ = concat(
      of([]),
      this.customerInput$.pipe(
        debounceTime(700),
        distinctUntilChanged(),
        switchMap((term) =>
          this.cs
            .apiServiceProviderCasesCustomerUserProductSelectGet(
              this.filter.page,
              this.filter.limit,
              term
            )
            .pipe(
              catchError(() => of([])),
              tap(() => {
                // console.log(term);
                this.customers = [];
              })
            )
        )
      )
    );
  }
  onCloseCustomer() {
    this.customers = this.defaultCustomers;
  }
  validateForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateForm(control);
      }
      this.app.tick();
    });
  }
  closeModal() {
    this.activeModal.dismiss();
  }
  saveModal() {
    if (this.caseForm.valid) {
        if (!this.isLoading) {
            this.isLoading = true;
            const currentUser = JSON.parse(localStorage.getItem("currentUser"));
              const requestBody = {
                userProductId: this.product.value,
                status: ECaseStatus.NewUnAssigned,
                reason: ECaseReason.Defective,
                servicePlace: EServicePlace.AtRepairshop,
                subject: this.subject.value,
                description: this.description.value,
                contactInfoMainContact: currentUser.mainContact,
                repairShopId: this.shop.value,
                photos: undefined,
                contactInfoAddress: undefined,
                contactInfoAddress2: currentUser.address2,
                contactInfoCity: undefined,
                contactInfoPostalCode: undefined,
                contactInfoCountry: undefined,
                contactInfoPhoneNumber: currentUser.phoneNumber,
                errorTypeErrorTypeId: this.errorType.value,
                errorTypeName: undefined,
                errorTypeActive : undefined,
                userAgent: ''
            };
                this.ccs
                    .apiCustomerCasesFormPost(
                      requestBody.userProductId,
                      requestBody.status,
                      requestBody.reason,
                      requestBody.servicePlace,
                      requestBody.subject,
                      requestBody.description,
                      requestBody.contactInfoMainContact,
                      requestBody.repairShopId,
                      requestBody.photos,
                      requestBody.contactInfoAddress,
                      requestBody.contactInfoAddress2,
                      requestBody.contactInfoCity,
                      requestBody.contactInfoPostalCode,
                      requestBody.contactInfoCountry,
                      requestBody.contactInfoPhoneNumber,
                      requestBody.errorTypeErrorTypeId,
                      requestBody.errorTypeName,
                      requestBody.errorTypeActive,
                      requestBody.userAgent,
                     
                    )
                    .subscribe(
                        () => {
                            this.activeModal.close();
                            this.isLoading = false;
                        },
                        (error) => {
                            this.isLoading = false;
                            console.error("Error:", error);
                        }
                    );
        }
    } else {
        this.validateForm(this.caseForm);
    }
}

}
